<template>
    <div class="ShowMore">

        <slot v-if="expanded" />

        <div class="ShowMore__button mt-base" @click="expanded = !expanded">
            <p v-if="expanded" class="text--blue">- Show less</p>
            <p v-else class="text--blue">+ Show more</p>
        </div>
    </div>
</template>
<script>

export default {
    name: 'show-more',
    data: () => ({
        expanded: false
    })
}
</script>
<style lang="scss" scoped>
    .ShowMore__button {
        position: relative;
        display: inline-block;
        cursor: pointer;

        &:before {
            content: '';
            position: absolute;
            width: 100%;
            height: 1px;
            border-bottom: 1px solid getColour('blue');
            bottom: -5px;
            left: 2px;
        }
    }
</style>
